// Utilitários de formatação

export const formatAddress = (address, startChars = 10, endChars = 10) => {
  if (!address || address.length <= startChars + endChars) {
    return address;
  }
  return `${address.substring(0, startChars)}...${address.substring(address.length - endChars)}`;
};

/**
 * Se o endereço estiver na lista de carteiras cadastradas, retorna o nome; senão retorna o endereço abreviado.
 * @param {Array<{ address?: string, name?: string }>} wallets - Lista de carteiras
 * @param {string} address - Endereço a resolver
 * @param {number} startChars - Caracteres no início (para formatAddress quando não cadastrado)
 * @param {number} endChars - Caracteres no fim
 * @returns {{ display: string, isRegistered: boolean }}
 */
export const getAddressOrWalletName = (wallets, address, startChars = 6, endChars = 4) => {
  if (!address) return { display: '', isRegistered: false };
  const addr = String(address).toLowerCase();
  const wallet = Array.isArray(wallets)
    ? wallets.find((w) => w?.address && String(w.address).toLowerCase() === addr)
    : null;
  if (wallet && wallet.name) {
    return { display: wallet.name.trim(), isRegistered: true };
  }
  return { display: formatAddress(address, startChars, endChars), isRegistered: false };
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('pt-BR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatDateTime = (date) => {
  return new Date(date).toLocaleString('pt-BR');
};

export const formatTime = (date) => {
  return new Date(date).toLocaleTimeString('pt-BR');
};

export const formatNumber = (value, decimals = 2) => {
  return parseFloat(value).toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

export const truncateString = (str, maxLength = 30) => {
  if (str.length > maxLength) {
    return str.substring(0, maxLength) + '...';
  }
  return str;
};
